import script from "./InformacionRelevante.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacionRelevante.vue?vue&type=script&setup=true&lang=js"

import "./InformacionRelevante.vue?vue&type=style&index=0&id=36b81606&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b81606"]])

export default __exports__